<template>
  <div>
    <b-form @submit="selectDocuments">
      <b-row>
        <b-col>
          <b-form-group label-align="right" :label="$t('Reason of creation')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select v-model="selected" :options="listOfReasons">
              <template slot="first">
                <option :value="null">{{ $t('Load from file') }}</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-align="right" :disabled="selected !== null" :label="$t('File')" enctype="multipart/form-data" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-file :placeholder="$t('Choose a file...')" accept=".odt, .pdf" v-model="file" required/>
          </b-form-group>
          <b-form-group label-align="right" :disabled="selected !== null" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="name" required/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="success" style="float: right ;width: 100px" type="submit">{{ $t('Save') }}</b-button>
        </b-col>
        <b-col sm="3">
          <b-button variant="secondary" style="float: right ;width: 100px" @click="hideSelectDocuments">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    currentRow: null
  },
  data () {
    return {
      selected: null,
      file: null,
      name: ''
    }
  },
  methods: {
    hideSelectDocuments () {
      this.$emit('hideSelectDocuments')
    },
    selectDocuments (event) {
      event.preventDefault()
      if (this.selected === null) {
        var reader = new FileReader()
        reader.onload = (event) => {
          var contents = event.target.result
          let payload = {
            user_id: this.currentRow.user_id,
            name: this.name,
            contents: contents
          }
          let response = this.$store.dispatch('Users/CREATE_CONTRACTS_UPLOAD', payload, payload)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$store.dispatch('Users/GET_CONTRACTS', this.currentRow.user_id)
              this.$root.$emit('makeToasts')
              this.hideSelectDocuments()
            }
          })
        }
        reader.onerror = function (event) {
        }
        reader.readAsArrayBuffer(this.file)
      } else {
        let payload = {
          user_id: this.currentRow.user_id,
          template_id: this.selected
        }
        let response = this.$store.dispatch('Users/CREATE_CONTRACTS', payload)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$store.dispatch('Users/GET_CONTRACTS', this.currentRow.user_id)
            this.$root.$emit('makeToasts')
            this.hideSelectDocuments()
          }
        })
      }
    }
  },
  computed: {
    listOfReasons () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/DOCUMENT_TEMPLATES'])).filter(function (value) {
        return Number(value.type) === 6
      })
      for (let el of copy) {
        el.value = el.template_id
        el.text = 'Template: ' + el.name + ' (' + el.template_id + ')'
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/documents/formSelectDocuments.vue